var dur = 0.35;

function carousel(options) {

  // media carousel
  $(options.current.querySelector(options.selector+'-mobile_media')).slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    fade: true,
    draggable: false,
    swipe: false,
  });

  // list carousel
  $(options.current.querySelector(options.selector+'-mobile_list')).slick({
    infinite: false,
    slidesToShow: 1.3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    asNavFor: $(options.current.querySelector(options.selector+'-mobile_media')),
  });
}

function setAccordionMedia(options) {
  var all = options.current.querySelectorAll(options.selector+'-desktop_media '+options.selector+'-desktop_image:not(.active)');
  TweenLite.set(all, {
    autoAlpha: 0,
    scale: 0.8,
  });
};

function showAccordionMedia(options, oldMedia, newMedia) {
  var toShow = options.current.querySelector(options.selector+'-desktop_media [data-index="'+newMedia+'"]');
  var toHide = options.current.querySelector(options.selector+'-desktop_media [data-index="'+oldMedia+'"]');

  TweenLite.set(toShow, {
    zIndex: 1
  });

  TweenLite.set(toHide, {
    zIndex: 0
  });

  TweenLite.to(toHide, dur, {
    autoAlpha: 0,
    scale: 0.8,
    ease: Power3.easeOut,
  });

  TweenLite.to(toShow, dur, {
    autoAlpha: 1,
    scale: 1,
    ease: Power3.easeOut,
  });
};

function accordion(options) {
  var allItems = options.current.querySelector(options.selector+'-desktop').querySelectorAll(options.selector+'-item');
  var activeItem = 1;

  setAccordionMedia(options);

  allItems.forEach(function(item) {
    // TweenLite.set(item.querySelector(options.selector+'-item_content'), {
    //   height: 0,
    // });

    item.querySelector('button').addEventListener('click', function() {
      var newActiveItem = parseInt(this.parentNode.getAttribute('data-index'));
      var activeCls = 'active';

      showAccordionMedia(options, activeItem, newActiveItem);

      TweenLite.to(item.parentNode.querySelector('[data-index="'+activeItem+'"] '+options.selector+'-item_content'), dur, {
        height: function(index, target) {
          target.parentNode.classList.remove(activeCls);
          return 0;
        },
        ease: Power3.easeOut,
      });

      activeItem = newActiveItem;

      TweenLite.to(item.parentNode.querySelector('[data-index="'+activeItem+'"] '+options.selector+'-item_content'), dur, {
        height: function(index, target) {
          var height = 0;
          Array.from(target.children).forEach(function(child) {
            var childStyles = window.getComputedStyle(child);
            var styles = ['margin-top', 'margin-bottom', 'padding-top', 'padding-bottom', 'border-top-width', 'border-bottom-width'];
            height += child.offsetHeight;
            styles.forEach(function(style) {
              height += parseInt(childStyles.getPropertyValue(style).split('px')[0]);
            });
          });
          target.parentNode.classList.add(activeCls);
          return height;
        },
        ease: Power3.easeOut,
      });

      window.addEventListener('resize', function() {
        // TweenLite.set(options.current.querySelector(options.selector+'-desktop .active '+options.selector+'-item_content'), {
        //   height: 0,
        // });
        TweenLite.to(options.current.querySelector(options.selector+'-desktop .active '+options.selector+'-item_content'), 0, {
          height: function(index, target) {
            var height = 0;
            Array.from(target.children).forEach(function(child) {
              var childStyles = window.getComputedStyle(child);
              var styles = ['margin-top', 'margin-bottom', 'padding-top', 'padding-bottom', 'border-top-width', 'border-bottom-width'];
              height += child.offsetHeight;
              styles.forEach(function(style) {
                height += parseInt(childStyles.getPropertyValue(style).split('px')[0]);
              });
            });
            return height;
          },
        });
      });
    });
  });

  // TweenLite.set(allItems[0].querySelector(options.selector+'-item_content'), {
  //   height: 'auto',
  // });
};




document.addEventListener('DOMContentLoaded', function() {
  window.addEventListener('load', function() {

    var selector = '.illustrated_accordion';
    var components = document.querySelectorAll(selector);

    if (components.length > 0) {
      components.forEach(function (component) {
        var config = {
          all: components,
          current: component,
          selector: selector,
        };
  
        carousel(config);
        accordion(config);
      });
    }
  });
});
